import { withAsyncBoundary } from '@toss/async-boundary';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { useBusinessPaymentResult } from '../../../services';
import { paymentFailureFromQuery, readPaymentFailure } from '../payment-tracking/paymentFailure';
import { PaymentFailureContent } from '../payment-tracking/PaymentFailureContent';
import { BusinessPaymentLayout } from './BusinessPaymentLayout';
import { BusinessPaymentInvalidPage } from './BusinessPayments';
import S from './BusinessPayments.module.scss';
const BusinessPaymentsFailInner = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['business']);
  const paymentHashId = (router.query.id ?? '').toString();
  const email = (router.query.email ?? '').toString();
  const {
    data: {
      businessPayment
    }
  } = useBusinessPaymentResult({
    paymentHashId,
    email
  });
  const queryFailure = paymentFailureFromQuery(router.query.paymentFailure);
  return <BusinessPaymentLayout title={businessPayment.customerName} data-sentry-element="BusinessPaymentLayout" data-sentry-component="BusinessPaymentsFailInner" data-sentry-source-file="BusinessPaymentsFail.tsx">
      <div className={S.payments_result_section}>
        <h2 className={S.payments_result_title}>
          {t('business:business_payments_failure')}
        </h2>
        <PaymentFailureContent as="div" metadata={{
        pg_provider: 'unknown',
        ...readPaymentFailure({
          pg_error_code: router.query.code
        }),
        ...queryFailure,
        // URL 쿼리는 사용자가 고칠 수 있다. 화면이 확실히 아는 값을 마지막에 둬 덮이지 않게 한다.
        payment_flow: 'business_payment',
        // 주문은 조회 응답 값으로 다시 만든다. 쿼리 reference 는 다른 주문으로 바꿀 수 있다.
        payment_reference_id: readPaymentFailure({
          payment_reference_id: `${queryFailure.pg_provider}_order:${businessPayment.orderId}`
        }).payment_reference_id
      }} data-sentry-element="PaymentFailureContent" data-sentry-source-file="BusinessPaymentsFail.tsx">
          <div>
            {t('business:business_payments_failure_content1', {
            name: businessPayment.customerName
          })}
          </div>
          <div>{t('business:business_payments_failure_content2')}</div>
        </PaymentFailureContent>
      </div>
      <Button className={S.retry_button} size="lg" onClick={() => router.replace(`/business/payments/${paymentHashId}`)} data-sentry-element="Button" data-sentry-source-file="BusinessPaymentsFail.tsx">
        {t('business:business_payments_retry_button')}
      </Button>
    </BusinessPaymentLayout>;
};
export const BusinessPaymentsFail = withAsyncBoundary(BusinessPaymentsFailInner, {
  pendingFallback: '',
  rejectedFallback: () => <BusinessPaymentInvalidPage />
});